import React, { useEffect } from 'react';
import { useNavigate, useLocation, matchPath } from 'react-router-dom';
import { isLogin } from '~~utils/Auth';
import { NO_LOGIN_PATH, MAIN_PATH } from './PathConstants';

const NO_LOGIN_PAGE = Object.values(NO_LOGIN_PATH);

const Authentication = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const checkLogin = () => {
    const loginFlag = isLogin();
    const isNoLoginPage = NO_LOGIN_PAGE.some((path) => matchPath(path, pathname));
    if (loginFlag) {
      // 有登入，但是還在登入頁，轉導到系統首頁
      if (isNoLoginPage || pathname === '/') navigate(MAIN_PATH.USER_PROFILE);
      // 沒有登入，且網址不在免登入白名單之內，將網址導至登入頁
    } else if (!isNoLoginPage) navigate(NO_LOGIN_PATH.LOGIN);
  };

  useEffect(() => {
    checkLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <div>{children}</div>;
};

export default Authentication;
